import { namespace } from 'wsm-tagging-utils';

const runCommand = (win) => {
	namespace(win, 'DDC.tracking.framework.runtime');

	const {
		DDC: { tracking },
		com
	} = win;

	/**
	 * Commands are executed on startup after the DDC Tracking Framework runtime has been initialized.
	 *
	 * @param {Object} window An instance of the global window object
	 * @param {tracking.framework.runtime.Page} page A Page instance for page related queries
	 * @param {tracking.framework.runtime.Form} form A Page instance for page related queries
	 * @constructor
	 * @see https://sourcemaking.com/design_patterns/command
	 */
	tracking.framework.runtime.Command = function Command(
		thisWin,
		page,
		eventHandler,
		form
	) {
		this.log = com.dealer.log.Logger.createFor(this);
		this.win = thisWin;
		this.page = page;
		this.form = form;
		this.eventHandler = eventHandler;
	};

	tracking.framework.runtime.Command.prototype = {
		/**
		 * The default constructor
		 */
		constructor: win.DDC.tracking.framework.runtime.Command,

		/**
		 * The logging category, subfclasses should override to appropriate value
		 */
		logCategory: 'ws-tagging:Command',

		/**
		 * Executes this Command
		 */
		execute() {}
	};
};

export default runCommand;
